(ns frontend.ui.component.lp-portal.voima-components.text-content.style
  (:require
   [frontend.ui.style.theme.core :as theme]
  ))

(defn edit-text
  []
  (with-meta
    {:display     "inline-block"
     :padding     ".5rem 0"
     :color       (theme/color [:text :primary :color])
     :cursor      :pointer
     :font-weight "bold"
     :position    "relative"}

    {:pseudo
     {:after
      {:content    "''"
       :display    "inline-block"
       :position   "absolute"
       :background (theme/color [:container-bgr :helper :bg])
       :height     "1px"
       :bottom     "0px"
       :left       "0px"
       :right      "0px"}}}))


(defn complete-label
  []
  (with-meta
    {:padding "12px 0"}
    {:combinators {}}))

(def prosemirror-content-combinators
  {[:descendant "a"]
   {:color (theme/color [:link :primary :color])}

   [:descendant "a:hover"]
   {:color (theme/color [:link :primary :hover])}

   [:descendant ".ProseMirror p"]
   {:margin "0.375rem 0"}

   [:descendant ".ProseMirror p:first-child"]
   {:margin-top 0}

   [:descendant ".ProseMirror p:last-child"]
   {:margin-bottom 0}

   [:descendant ".ProseMirror ul"]
   {:list-style-type "disc"
    :list-style-position "outside"
    :padding-left "1.5rem"
    :margin "0.5rem 0"}

   [:descendant ".ProseMirror ol"]
   {:list-style-type "decimal"
    :list-style-position "outside"
    :padding-left "1.5rem"
    :margin "0.5rem 0"}

   [:descendant ".ProseMirror li"]
   {:display "list-item"
    :margin "0.25rem 0"}

   [:descendant ".ProseMirror h1"]
   {:font-size "1.5rem"
    :line-height "2rem"
    :font-weight "700"
    :margin "1rem 0 0.5rem"}

   [:descendant ".ProseMirror h2"]
   {:font-size "1.25rem"
    :line-height "1.75rem"
    :font-weight "700"
    :margin "0.75rem 0 0.5rem"}

   [:descendant ".ProseMirror h3"]
   {:font-size "1.125rem"
    :line-height "1.75rem"
    :font-weight "700"
    :margin "0.5rem 0 0.5rem"}})

(defn text-container
  [draft? background-color?]
  (if draft?
    (with-meta
      {:padding       "12px"
       :border-radius "4px"
       :background    "#fffaef"
       :margin-top    "16px"}
      {:combinators prosemirror-content-combinators})
    (with-meta
      {:background-color (when background-color? (theme/color [:palette :grey-20]))
       :border-radius    "8px"
       :padding          "10px"}
      {:combinators prosemirror-content-combinators})))

(defn draft-indicator
  []
  (with-meta
    {:margin-bottom  "8px"
     :font-weight    "bold"
     :text-transform "uppercase"}
    {:combinators {}}))

(defn complete-label-text
  []
  (with-meta
    {:padding "0 6px"}
    {:combinators {}}))
